if (!customElements.get('highlight-slider')) {
  class HighlightSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      window.addEventListener('shopify:section:load', () => {
        this.initSlider(swiperOptions);
      });

      this.initSlider(swiperOptions);

      if (this.classList.contains("js-hightlights")) {
        const initOrUpdateSlider = () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider && this.slider.params.effect === "slide";

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        };

        initOrUpdateSlider();

        window.addEventListener("resize", initOrUpdateSlider);
      }

      // if window is resized, handle slider state
      window.addEventListener('resize', () => {
        
        this.classList.remove('hightlights__desktop-centered');

        if (swiperOptions.slideCount < 8 && window.innerWidth > 990) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          this.classList.add('hightlights__desktop-centered');
        } else if (swiperOptions.slideCount < 9 && window.innerWidth > 1199) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          this.classList.add('hightlights__desktop-centered');
        } else if (swiperOptions.slideCount < 10 && window.innerWidth > 1399) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          this.classList.add('hightlights__desktop-centered');
        } else if (swiperOptions.slideCount < 11 && window.innerWidth > 1499) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          this.classList.add('hightlights__desktop-centered');
        } else if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
        } else if (!this.slider && !this.swiperLoading) {
          this.initSlider(swiperOptions);
        }
      });
    }

    reInitSlider(swiperOptions) {
      this.slider?.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {

      if (swiperOptions.disabledOnDesktop && window.innerWidth > tabletWidth) {
        return;
      }

      if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
        return;
      }

      let sliderOptions = {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: swiperOptions.spaceBetweenMobile ?? 16,
        resistanceRatio: 0.72,
        breakpoints: {
          480: {
            slidesPerView: 'auto',
            spaceBetween: swiperOptions.spaceBetweenMobile || 2
          },
          990: {
            slidesPerView: 8,
            spaceBetween: swiperOptions.spaceBetweenDesktop ?? 16
          },
          1199: {
            slidesPerView: 9,
          },
          1399: {
            slidesPerView: 10,
          },
          1499: {
            slidesPerView: 11,
          }
        }
      };

      this.swiperLoading = true;
      loadSwiperLibrary().then(() => {
        this.swiperLoading = false;
        this.slider = new Swiper(this, sliderOptions);
      });
    }
  }

  customElements.define('highlight-slider', HighlightSlider);
}
